<template>
    <div>
      <p>어드민 푸터</p>
    </div>
</template>

<script>
export default {
  name: 'AdminFooter'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Section/AdminFooter.vue